'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
var loader = require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var fontIcon = require('../../icon/font-icon/font-icon.js');
var circleLoader = require('../../loader/circle-loader/circle-loader.js');
require('../../loader/shimmer-loader/shimmer-loader.js');
var baseButton = require('../base-button/base-button.js');
var tileButton_module = require('./styles/tile-button.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const TileButton = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className , description , descriptionProps , disabled , heading , headingProps , icon , iconProps , loaderLabel , loaderProps , loading , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseButton.BaseButton, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-button__tile--disabled': disabled,
            'bf-button__tile--has-description': !!description,
            'bf-button__tile--has-icon': !!icon,
            'bf-button__tile--loading': loading,
            [tileButton_module['tile-button']]: true,
            [tileButton_module['tile-button--loading']]: loading,
            [`${className}`]: className
        }),
        ref: ref,
        variant: button.ButtonVariants.Tile
    }), loading && loaderLabel ? /*#__PURE__*/ React__default.default.createElement(circleLoader.CircleLoader, _extends({
        label: loaderLabel,
        look: loader.LoaderLooks.Primary,
        size: loader.LoaderSizes.Small
    }, loaderProps, {
        className: classnames__default.default({
            'bf-button__tile-icon__loader': true,
            [`${loaderProps?.className}`]: !!loaderProps?.className
        })
    })) : /*#__PURE__*/ React__default.default.createElement(React__default.default.Fragment, null, icon && /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, _extends({}, iconProps, {
        "aria-hidden": true,
        className: classnames__default.default({
            'bf-button__tile-icon': true,
            [tileButton_module['tile-button__icon']]: true,
            [`${iconProps?.className}`]: iconProps?.className
        }),
        icon: icon
    })), /*#__PURE__*/ React__default.default.createElement("strong", _extends({}, headingProps, {
        className: classnames__default.default({
            'bf-button__tile-heading': true,
            [tileButton_module['tile-button__heading']]: true,
            [`${headingProps?.className}`]: headingProps?.className
        })
    }), heading), description && /*#__PURE__*/ React__default.default.createElement("small", _extends({}, descriptionProps, {
        className: classnames__default.default({
            'bf-button__tile-description': true,
            [tileButton_module['tile-button__description']]: true,
            [`${descriptionProps?.className}`]: descriptionProps?.className
        })
    }), description)));
});

exports.TileButton = TileButton;
//# sourceMappingURL=tile-button.js.map
